import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Hook to check if the current user is a Teacher or Co-Teacher for a given classroom
 * @param {string|null} classroomId - The classroom ID to check (null for private modules)
 * @returns {boolean|null} - true if user is Teacher or Co-Teacher, false if not, null while loading
 */
export const useIsClassroomHead = (classroomId) => {
  const [isHead, setIsHead] = useState(null);

  useEffect(() => {
    // If no classroom_id, it's a private module - user is always "head" (owner)
    if (!classroomId) {
      setIsHead(true);
      return;
    }

    const checkHeadStatus = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const userId = session?.user?.id;
        
        if (!userId) {
          setIsHead(false);
          return;
        }

        // Check if user has Teacher or Co-Teacher role in this classroom
        const { data, error } = await supabase
          .from('classroom_members')
          .select('class_roll')
          .eq('classroom_id', classroomId)
          .eq('user_id', userId)
          .single();

        if (error || !data) {
          setIsHead(false);
          return;
        }

        // User is a "head" if they have Teacher or Co-Teacher role
        setIsHead(data.class_roll === 'Teacher' || data.class_roll === 'Co-Teacher');
      } catch (err) {
        console.error('Error checking classroom head status:', err);
        setIsHead(false);
      }
    };

    checkHeadStatus();
  }, [classroomId]);

  return isHead;
};

